import { render } from "./FavCard.vue?vue&type=template&id=5a419e15&scoped=true"
import script from "./FavCard.vue?vue&type=script&lang=js"
export * from "./FavCard.vue?vue&type=script&lang=js"

import "./FavCard.vue?vue&type=style&index=0&id=5a419e15&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a419e15"]])

export default __exports__